import { BoolFilter } from "@dash/filters";
import { SearchBox } from "@dash/search";

export type CartsFilterValues = {
  isArchived?: boolean;
  hasRewards?: boolean;
  excludeEmpty?: boolean;
  searchTerm?: string;
};

type Props = {
  values: CartsFilterValues;
  onChange: (patch: Partial<CartsFilterValues>) => void;
  className?: string;
};

export const CartsFilters: React.FC<Props> = ({ values, onChange, className }) => {
  return (
    <div className={className} css={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "center" }}>
      <SearchBox
        value={values.searchTerm ?? ""}
        onChange={(value) => onChange({ searchTerm: value })}
      />
      <BoolFilter
        label="Archiwalne"
        value={values.isArchived}
        onChange={(v) => onChange({ isArchived: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
      <BoolFilter
        label="Z nagrodami"
        value={values.hasRewards}
        onChange={(v) => onChange({ hasRewards: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
      <BoolFilter
        label="Ukryj puste"
        value={values.excludeEmpty}
        onChange={(v) => onChange({ excludeEmpty: v })}
        falseLabel="Nie"
        trueLabel="Tak"
      />
    </div>
  );
};
